/**
 * Language store - centralized language management for API calls
 */

let language = localStorage.getItem('preferredLanguage') || 'en';

/**
 * Get the current language
 */
export const getLanguage = (): string => language;

/**
 * Set the current language
 */
export const setLanguage = (newLang: string): void => {
    language = newLang;
    localStorage.setItem('preferredLanguage', newLang);
};
